import { MAX_STORE_NAME_ATTEMPTS } from '@cli-constants/limits.js'
import { versionedVercelProjectName } from '../project/versioned-vercel-project-name.js'

export function candidateStoreName(baseName: string, attempt: number): string {
  if (attempt < MAX_STORE_NAME_ATTEMPTS) return versionedVercelProjectName(baseName, attempt)
  const suffix = `-${Date.now().toString(36)}`
  return `${baseName.slice(0, 100 - suffix.length)}${suffix}`
}
